import { PageAction } from 'vrlcm-gui-types';
import { ROUTES } from '../constants/RouteConstants';
import { l10n } from 'i18n/i18nUtil';

export const quickActions: PageAction[] = [
  {
    action: {
      route: ROUTES.ENVIRONMENT_WORKFLOW
    },
    icon: 'vm',
    name: l10n('lcops.dashboard.createEnvironment'),
    color: '#4d7519'
    // backgroundColor: '#78BE20'
  },
  {
    action: {
      route: ROUTES.ENVIRONMENTS
    },
    icon: 'cluster',
    name: l10n('lcops.dashboard.manageEnvironments'),
    color: '#0370a7'
    // backgroundColor: '#0091DA'
  },
  {
    action: {
      route: ROUTES.DATACENTERS
    },
    icon: 'building',
    name: l10n('lcops.dashboard.manageDataCenters'),
  },
  {
    action: {
      route: ROUTES.REQUESTS
    },
    icon: 'list',
    name: l10n('lcops.dashboard.viewRequests'),
    color: '#127682'
    // backgroundColor: '#00C1D5'
  }
];
